import React from 'react';
import { Route, IndexRoute } from 'react-router';
import PaymentLinks from './PaymentLinks';
import PaymentLinkCreate from './PaymentLinkCreate';
import PaymentLinksReport from './PaymentLinksReport';

export default (
  <Route path="payment-links">
    <IndexRoute component={(props) => <PaymentLinks {...props} />} />
    <Route path="create" component={(props) => <PaymentLinkCreate {...props} />} />
    <Route path="report" component={(props) => <PaymentLinksReport {...props} />} />
  </Route>
);
